export const roleRank = {
  viewer: 1,
  operator: 2,
  manager: 3,
  admin: 4,
  super_admin: 5,
};

export const routePolicies = [
  { path: '/dashboard' },
  { path: '/operations-control', moduleKey: 'workflows', requiredRole: 'manager' },
  { path: '/document-processing', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/route-templates', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/validation-rules', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/capture-settings', moduleKey: 'document_processing', requiredRole: 'admin' },
  { path: '/capture-activity', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/erp-settings', moduleKey: 'document_processing', requiredRole: 'admin' },
  { path: '/staged-records', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/grn-receiving', moduleKey: 'document_processing', requiredRole: 'manager' },
  { path: '/ap-workbench', moduleKey: 'ap', requiredRole: 'manager' },
  { path: '/collections-workbench', moduleKey: 'collections', requiredRole: 'manager' },
  { path: '/finance-action-ledger', moduleKey: 'ap', requiredRole: 'manager' },
  { path: '/supplier-payments', moduleKey: 'supplier_payments', requiredRole: 'manager' },
  { path: '/collections', moduleKey: 'collections', requiredRole: 'manager' },
  { path: '/ar-collections', moduleKey: 'collections', requiredRole: 'manager' },
  { path: '/ar-analytics', moduleKey: 'collections', requiredRole: 'manager' },
  { path: '/ar-disputes', moduleKey: 'collections', requiredRole: 'manager' },
  { path: '/purchase-management', moduleKey: 'rfq', requiredRole: 'manager' },
  { path: '/pr-management', moduleKey: 'rfq', requiredRole: 'manager' },
  { path: '/cashflow', moduleKey: 'cashflow', requiredRole: 'manager' },
  { path: '/finance-scenarios', moduleKey: 'cashflow', requiredRole: 'manager' },
  { path: '/financial-forecast', moduleKey: 'financial_forecast', requiredRole: 'manager' },
  { path: '/tenant-onboarding', requiredRole: 'manager' },
  { path: '/organisation', requiredRole: 'manager' },
  { path: '/settings', requiredRole: 'manager' },
  // what the company pays is for its administrators
  { path: '/plan', requiredRole: 'admin' },
  { path: '/modules', requiredRole: 'admin' },
  { path: '/users', requiredRole: 'admin' },
  // the stock manager's review of SAP's variance card
  { path: '/sap-variances', moduleKey: 'consignment', requiredRole: 'manager' },
  // the packs branch staff scanned as sold
  { path: '/scanned-sales', moduleKey: 'stock_count' },
  // every batch with its dates, and each item's shelf life
  { path: '/batches', moduleKey: 'stock_count' },
  // the branches' orders on the store (IPOs), on a page of their own
  { path: '/transfer-requests', moduleKey: 'transfer_requests' },
  { path: '/routes', moduleKey: 'transfer_requests' },
  // WhatsApp is open to the people an administrator has named (or, with
  // nobody named, to managers and above). The server says whether this
  // person is one of them; the menu and the page both listen.
  { path: '/whatsapp-sales', moduleKey: 'whatsapp_sales', accessKey: 'whatsapp_sales' },
  // Acuon's own view of what the AI costs across a tenant — ours, not the
  // customer's. A tenant admin is the top of the tenant, not the platform.
  { path: '/token-usage', platformOnly: true },
];

export const isPlatformAdmin = (user = {}) =>
  user.is_platform_admin === true || user.role === 'super_admin';

export function getRoutePolicy(path) {
  return routePolicies.find((policy) => policy.path === path) || {};
}

export function canUseRoute(policy = {}, user = {}, enabledModules = null) {
  if (policy.platformOnly && !isPlatformAdmin(user)) {
    return { allowed: false, reason: 'platform' };
  }
  if (policy.requiredRole) {
    const userLevel = roleRank[user.role] || 0;
    const requiredLevel = roleRank[policy.requiredRole] || 0;
    if (userLevel < requiredLevel) {
      return { allowed: false, reason: 'role' };
    }
  }
  if (policy.accessKey && enabledModules) {
    // a page open to named people: false means the server said this person
    // is not one of them; unknown (not asked yet) lets the page decide
    if (enabledModules[`access_${policy.accessKey}`] === false) {
      return { allowed: false, reason: 'access' };
    }
  }
  if (policy.moduleKey && enabledModules) {
    const enabled = enabledModules[`module_${policy.moduleKey}`];
    if (enabled === false) {
      return { allowed: false, reason: 'module' };
    }
  }
  return { allowed: true, reason: '' };
}
